



import { defineComponent } from '@vue/composition-api';
import Vue from 'vue';
import { VClosePopover } from 'v-tooltip';

Vue.directive('close-popover', VClosePopover);

/**
 * Simple component to be used as option e.g. for OlbSelect component.
 * Tests and stories for it can be found in the `select` folder.
 */
export default defineComponent({
	setup(props, { emit }) {
		function clickHandler(event: Event): void {
			emit('click', event);
		}
		return { clickHandler };
	},
});
